<template>
  <v-data-table
    :headers="headers"
    :items="forms"
    class="elevation-1 table-cursor-hand"
    :items-per-page="15"
    :footer-props="{
      itemsPerPageOptions: [15, 30, -1],
      itemsPerPageText: $t('table.itemsPerPageText')
    }"
    :search="search"
    :custom-filter="filterItems"
    sort-by="created_at"
    sort-desc
    @click:row="clickRow"
    :loading="loading"
    :loading-text="$t('table.loading')"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>{{ $t("table.historicForms") }}</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('search')"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>
    <template v-slot:item.created_at="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <span v-on="on">{{ timeDifference(new Date(item.created_at)) }}</span>
        </template>
        <span
          >{{ new Date(item.created_at).toISOString().substr(0, 10) }}
          {{ new Date(item.created_at).toTimeString().substr(0, 8) }}</span
        >
      </v-tooltip>
    </template>
    <template v-slot:item.state="{ item }">
      <div class="d-flex justify-center">
        <ModeratedOperationState
          :state="item.state"
          :finished="item.finished"
          :authorized="item.authorized"
          :form-name="item.form_name"
          display="stepper-text"
          text-variant="userfriendly"
        />
      </div>
    </template>
    <template v-slot:item.form_name="{ item }">
      <span>{{$t(item.object_type + '.title')}} - {{ getFormName(item.form_name) }}</span>
    </template>
    <template v-slot:body.append>
      <tr>
        <td>
          <v-col>
            <v-select
              v-model="stateSelect"
              :items="itemsStateSelect"
              :label="$t('state.state')"
              item-text="text"
              item-value="value"
              multiple
              clearable
              hide-details
              ><template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2">
                  <span>{{ item.value }}</span>
                </v-chip>
                <span v-if="index === 2" class="grey--text caption"
                  >(+{{ stateSelect.length - 2 }} others)</span
                >
              </template></v-select
            >
          </v-col>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import axios from "axios";
import investigatorTablesMethods from "../../mixins/investigatorTablesMethods";
import ModeratedOperationState from "../reusables/ModeratedOperationState";
export default {
  mixins: [investigatorTablesMethods],
  components: { ModeratedOperationState },
  data() {
    return {
      search: "",
      loading: true,
      forms: [],
      stateSelect: [],
      itemsStateSelect: [
        {
          text:
            this.$t("state.pv")
              .charAt(0)
              .toUpperCase() +
            this.$t("state.pv")
              .slice(1)
              .toLowerCase(),
          value: "PV"
        },
        {
          text:
            this.$t("state.rj")
              .charAt(0)
              .toUpperCase() +
            this.$t("state.rj")
              .slice(1)
              .toLowerCase(),
          value: "RJ"
        },
        {
          text:
            this.$t("state.vd")
              .charAt(0)
              .toUpperCase() +
            this.$t("state.vd")
              .slice(1)
              .toLowerCase(),
          value: "VD"
        },
        {
          text:
            this.$t("state.pc")
              .charAt(0)
              .toUpperCase() +
            this.$t("state.pc")
              .slice(1)
              .toLowerCase(),
          value: "PC"
        }
      ]
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t("state.state"),
          value: "state",
          width: "15%",
          align: "center",
          filter: value => {
            if (!this.stateSelect.length) return true;

            return this.stateSelect.includes(value);
          }
        },
        {
          text: this.$t("name"),
          value: "title",
          filter: value => {
            if (!this.search) return true;
            return value.toString().indexOf(this.search) !== -1;
          }
        },
        { text: this.$t("formName"), value: "form_name"},
        { text: this.$t("create"), value: "created_at"}
      ];
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let path =
        this.$store.state.endpoint + "/user/moderatedOperations/historic";
      axios
        .get(path)
        .then(response => {
          this.forms = response.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },

    filterItems(value, search, item) {
      return (
        item.title != null &&
        search != null &&
        typeof item.title === "string" &&
        item.title.toString().indexOf(search) !== -1
      );
    },
    clickRow(item) {
      let path;
      if (item.state === "RJ" && item.form_name !== "deleteRequest") {
        path = `/my-forms/${item.object_type}/${item.form_name}/${item.id}`;
      } else if (item.form_name !== "deleteRequest") {
        path = `/my-forms/${item.object_type}/see/${item.form_name}/${item.id}`;
      } else {
        path = `/my-forms/${item.object_type}/delete/see/${item.id}`;
      }
      this.$router.push({
        path: path
      });
    }
  }
};
</script>
